<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card class="card-plain">
          <!-- <template slot="header">
            <h4 class="card-title">Table on Plain Background</h4>
            <p class="category">Here is a subtitle for this table</p>
          </template>-->
          <div class="table-full-width text-left">
            <submenu-table
            v-if="submenus && submenus.length > 0"
				:title="table1.title"
				:sub-title="table1.subTitle"
				:submenus="submenus"
				:totalElements="totalElements"
				:page="page"
				:columns="table1.columns"
 				@get-all-submenus="getAllSubmenus"
             >

            </submenu-table>
          </div>
        </card>
      </div>

    </div>
  </div>
</template>
<script>
import { Card } from "@/components/Card";

import SubmenuTable from "@/components/SubmenuTable";
import SubmenuService from "../services/SubmenuService";

const tableColumns = [];
const tableData = [
];

export default {
  components: {
    Card,
    SubmenuTable,
  },
  data() {
    return {
      submenus: [],
	  totalElements: 0,
      page: 0,
      searchQuery: '',     
      table1: {
        title: "Simple Table",
        columns: [...tableColumns],
        data: [...tableData],
      },
    };
  },
  methods: {
    async getAllSubmenus(sortBy='submenuId',sortOrder='true',page="0",size="50") {
      try {
        try {
			const searchDTO = {
				sortBy: sortBy, 
				sortOrder: sortOrder, 
				searchQuery: this.searchQuery,
				page: page, 
				size: size
			};
	        let response = await SubmenuService.getAllSubmenus(searchDTO);
	        if (!response.data.empty) {
		        if (response.data.submenus.length) {
					this.submenus = response.data.submenus;
				}
      			this.totalElements = response.data.totalElements;
      			this.page = response.data.page;
	        }
        } catch (error) {
          console.error("Error fetching submenus:", error);
        }
        
      } catch (error) {
        console.error("Error fetching submenu details:", error);
      }
    },
  },
  mounted() {
    this.getAllSubmenus();
  },
  created() {
    this.$root.$on('searchQueryForSubmenusChanged', (searchQuery) => {
    	this.searchQuery = searchQuery;
    	this.getAllSubmenus();
    })
  }
};
</script>
<style></style>
